import { BaseModel } from "./base";

export class Localidade extends BaseModel {
  constructor(public id: number, public nome: string, isMunicipio: boolean) {
    super(id);
  }
}
